// extracted by mini-css-extract-plugin
export default {"iframe":"kaltura__iframe__nbH3G"};